import { inject, Injectable, OnDestroy } from '@angular/core';
import { RootStore } from '@sama/app-state';
import { assert, isDefined } from '@sama/js-core';
import { isEmpty } from 'lodash';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { logStateToDevtools } from '../../../cross-team-shared/test-helpers/state-logging';
import { SampleTask } from '../../../team-apis/otterdam/sample-task';
import { FeatureFlagService } from '../../shared/misc-services/feature-flag.service';
import { SamplingWorkspaceState } from './sampling-workspace-state';

@Injectable()
export class SamplingWorkspaceStore
  extends RootStore<SamplingWorkspaceState>
  implements OnDestroy
{
  private devtoolSubscription: Subscription;
  private featureFlagsService = inject(FeatureFlagService);

  constructor() {
    super({} as SamplingWorkspaceState);
    this.devtoolSubscription = logStateToDevtools(
      this,
      'SamplingWorkspaceStore',
    );
  }

  hasSampleFinalized() {
    return (
      !isEmpty(this.state()) &&
      ['finalized', 'reworking', 'reworked'].includes(
        this.state().sample.status,
      )
    );
  }

  hasSampleFinalized$() {
    return this('sample')('status').$.pipe(
      map(() => this.hasSampleFinalized()),
    );
  }

  ngOnDestroy() {
    this.devtoolSubscription.unsubscribe();
  }

  updateFeedbackCount(offset: number) {
    if (!this.featureFlagsService.hasFlag('new-sampling-nav')) {
      return;
    }
    const position = this.state().position;
    this('sampleTasks').mutateUsing((sampleTasks) => {
      const currentTask = sampleTasks[position - 1];
      assert(
        isDefined(currentTask.feedbackCount),
        'currentTask and feedbackCount must be defined',
      );
      currentTask.feedbackCount += offset;
    });
  }
}

export function getContext(master: SampleTask) {
  return master.context || 'internal_qa';
}
